import {
    Input,
    Component,
    Output,
    EventEmitter,
    Inject
} from '@angular/core';

import { TOAST_DATA } from '../toastr.service';

@Component({
    selector: 'app-toast-success-from-steam',
    templateUrl: './toast-success-from-steam.component.pug',
    styleUrls: ['./toast-success-from-steam.component.less'],
})
export class ToastSuccessFromSteamComponent {
    @Input() count: number = null;

    @Output() select: EventEmitter<void> = new EventEmitter();

    constructor(
        @Inject(TOAST_DATA) public data: any
    ) {
    }

    onSelect() {
        this.select.emit();
    }
}
